import { render, staticRenderFns } from "./ModalComp.vue?vue&type=template&id=c9bb3b08"
import script from "./ModalComp.vue?vue&type=script&lang=js"
export * from "./ModalComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports